import React from "react";
import {ROUND_TYPES_DISPLAY_NAMES_MAP} from "@nextlot/core/webcast/data/WebcastDataDomain";
import {ReduxWebcastCurrentRoundType} from "@nextlot/core/webcast/redux/webcast/reducerWebcastCurrentRound";
import {Lot} from "@nextlot/core/webcast/data/data_types_definitions";
import NextLotJSDATA from "@nextlot/core/NextLotJSDATA";


type OnsiteInfoHeaderCmpPropsType = {
    currentRound: ReduxWebcastCurrentRoundType,
    lotsMapById: Map<number, Lot>,
};

export default function OnsiteInfoHeaderCmp(props: OnsiteInfoHeaderCmpPropsType) {

    return <>
        <div className="onsite-container-header p-2">
            <div className="row py-2 align-items-center">
                <div className="col-2">
                    <img src={NextLotJSDATA.site_logo_image_url} alt="Logo" className="site-logo" />
                </div>
                <div className="col-10">
                    <h1>{ROUND_TYPES_DISPLAY_NAMES_MAP.get(props.currentRound.roundType)}: {props.currentRound.lotsIds.map(lotId => `#${props.lotsMapById.get(lotId).number}`).join(", ")}</h1>
                </div>
            </div>
        </div>
    </>
}
